import React from 'react';
import { Heading, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';
import { Collapse } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const SectionMultiEnumMaybe = props => {
  const { heading, options, selectedOptions, showUnselectedOptions = true, count } = props;
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }
  const sectionClass = heading === 'Accessories' ? css.sectionAccessories : css.sectionMultiEnum

  return (

    <section className={sectionClass}>
      {/*<Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <PropertyGroup
        id="ListingPage.amenities"
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        showUnselectedOptions={showUnselectedOptions}
      />*/}

<Collapse
    bordered={false}
    expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
  >
    <Panel header={heading} key="1" >
    <PropertyGroup
        id="ListingPage.amenities"
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        showUnselectedOptions={showUnselectedOptions}
      />
    </Panel>
    {count == 1?
    <><Panel header='SHIPPING' key='2'>
            <p>This will be by default on all listings</p>
          </Panel><Panel header='PAYMENT' key='3'>
              <p>This will be by default on all listings</p>
            </Panel><Panel header='RETURNS & REFUND' key='4'>
              <p>This will be by default on all listings</p>
            </Panel></> : null }
  </Collapse>
  <br></br>


    </section>

  );
};

export default SectionMultiEnumMaybe;
